export default "__VITE_ASSET__DkYEt9zQ__"